import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import AccountBoxRoundedIcon from '@material-ui/icons/AccountBoxRounded';

import { CardIcon } from './icons/card-icon';
import { FilesIcon } from './icons/files-icon';
import { NavItemType } from './types';

const cardNavItems: NavItemType[] = [
  {
    label: 'VPUK__NAV__ALL_CARDS',
    linkTo: '/portal/prukazy',
    Icon: FormatListBulletedIcon,
  },
  {
    label: 'VPUK__NAV__ACTIVE_CARDS',
    linkTo: '/portal/prukazy/aktivni',
    Icon: CheckCircleRoundedIcon,
  },
  {
    label: 'VPUK__NAV__BLOCKED_CARDS',
    linkTo: '/portal/prukazy/blokovane',
    Icon: LockRoundedIcon,
  },
];

export const rootNavItems: NavItemType[] = [
  {
    label: 'VPUK__NAV__MY_CARDS',
    linkTo: '/portal/prukazy',
    Icon: CardIcon,
    subItems: cardNavItems,
  },
  {
    label: 'VPUK__NAV__MY_FILES',
    linkTo: '/portal/soubory',
    Icon: FilesIcon,
  },
  {
    label: 'VPUK__NAV__PROFILE',
    linkTo: '/portal/profil',
    Icon: AccountBoxRoundedIcon,
  },
];
